import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import "./Payment.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import SendPayment from "./SendPayment";

export default function Payment() {
  const [user_id, setUserId] = useState(null);
  const navigate = useNavigate();
  const [subscriptionType, setSubscriptionType] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);
        if (!protectedData) {
          navigate("/login");
          return;
        }
        setUserId(protectedData);
        const fetchSubscriptionStatus = async () => {
          const response = await fetch(`/api/subscription/?user_id=${user_id}`);
          const data = await response.json();
          setSubscriptionType(data.status);
        };
        fetchSubscriptionStatus();
      } catch (err) {
        navigate("/login");
      }
    };
    fetchData();
  }, [navigate]);

  const handleOpenModal = () => {
    setShowEmailModal(true);
  };


  return (
    <div className="payment-page">
      <Header />

      <div className="payment-container">
        <h1 className="payment-title">Выбери свой план</h1>

        <div className="plans-wrapper">
          <div className="plan-card premium-plan">
            <div className="plan-header">
              <h2 className="plan-title">Премиум</h2>
              <p className="plan-price">
                <span className="bolds">₽1999</span>/мес
              </p>
            </div>
            <ul className="plan-features">
              <li>Доступ ко всем курсам</li>
              <li>Возможность общения с PAI</li>
              <li>Доступ к огромному списку задач</li>
              <li>Одна генерация курса в месяц</li>
            </ul>
            <label
              style={{
                margin: "5px 0",
                marginBottom: "18px",
                fontFamily: "Roboto, monospace",
                fontSize: "14px",
              }}
            >
              Продолжая, я соглашаюсь с&nbsp;
              <Link to="/docs/legal" target="_blank" style={{ color: "grey" }}>
                публичной офертой
              </Link>
            </label>
            {subscriptionType === "active" ? (
              <button className="plan-button use-btn">Используется</button>
            ) : (
              <button
                className="plan-button choose-btn"
                onClick={handleOpenModal}
              >
                Выбрать
              </button>
            )}
          </div>

          <div className="plan-card free-plan">
            <div className="plan-header">
              <h2 className="plan-title">Бесплатно</h2>
              <p className="plan-price">
                <span className="bolds">₽0</span>/мес
              </p>
            </div>
            <ul className="plan-features">
              <li>Доступ к бесплатным курсам</li>
              <li>Возможность общения с PAI</li>
              <li>Доступ к огромному списку задач</li>
            </ul>
            {subscriptionType !== "active" ? (
              <button className="plan-button use-btn">Используется</button>
            ) : (
              <button className="plan-button choose-btn">Выбрать</button>
            )}
          </div>
        </div>
      </div>
      {showEmailModal && (
        <SendPayment onClose={() => setShowEmailModal(false)} user_id={user_id} />
      )}
    </div>
  );
}
